import AWS from 'aws-sdk';
import { generateFilename } from './utils/methods';

const s3 = new AWS.S3({
  accessKeyId: 'AKIA5FXG2RX3NPEQIWPN',
  secretAccessKey: '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',
  region: 'us-east-1',
  params: {
    Bucket: 'dogood-dev-bucket',
  },
});

export const uploadFile = (file: File | string, setState: (is: string) => void): void => {
  const fileName = generateFilename('jpg');
  const params = {
    Bucket: 'dogood-dev-bucket',
    Key: `public/${fileName}`,
    Body: file,
  };

  s3.putObject(params, (err, data) => {
    if (err) {
      console.error(err);
    }
    else {
      const result = getUrlFromBucket(s3, fileName);
      setState(result);
    }
  });
};

export const returnUrl = (fileName: string): string | null => {
  try {
    return getUrlFromBucket(s3, fileName);
  }
  catch (error) {
    console.error(error);
  }

  return null;
};

export const getUrlFromBucket = (s3Bucket: any, fileName: string) => {
  const {
    config: {
      params,
      region,
    },
  } = s3Bucket;
  const regionString = region.includes('us-east-1') ? '' : `-${region}}`;
  return `https://${params.Bucket}.s3${regionString}.amazonaws.com/public/${fileName}`;
};
